<template lang="pug">
  div
    .necessary__action-block
      .necessary__form
        div
          label.label.form-group__label.semibold НВВ
          e-input.form__elem_input(
            name="nvv"
            inputType="input"
            :model="fields"
            :disabled="true"
          )
        div
          label.label.form-group__label.semibold %
          e-input.form__elem_input(
            name="nvv_percent"
            inputType="input"
            :model="fields"
          )
        div
          label.label.form-group__label.semibold Сумма
          input.input.form__elem_input(
            v-model="nvvSum"
            disabled
          )
      .necessary__buttons
        button.button.button_usual(@click='getOperatorPlannedPurchases') Рассчитать
        div
          select.select.e-year-select(v-model="plannedYear" @change="getOperatorPlannedPurchases")
            option(v-for="option in yearsOptions" :value="option.id") {{option.name}}
        e-button-add(
          btnDefaultClass="button_add button button_icon"
          @click="showAddPlans = true"
          title="Добавить целевой показатель"
        )
        button.reset-btn.button.button_delete.button_icon(
          v-if="operatorInput"
          @click="deletePlannedItem"
        )
    .table.necessary__table
      .table__row
        .table__col.table__head.table__col_small Номер
        .table__col.table__head Наименование
        .table__col.table__head.table__col_small Единица измерения
        .table__col.table__head.table__col_third.necessary__years
          .necessary__year
            span.necessary__year-text План
          .necessary__year-row
            .necessary__year-col.necessary__year-col_third Цена
            .necessary__year-col.necessary__year-col_third Количество
            .necessary__year-col.necessary__year-col_third Сумма
        .table__col.table__head.table__col_third.necessary__years
          .necessary__year
            span.necessary__year-text Факт
          .necessary__year-row
            .necessary__year-col.necessary__year-col_third Цена
            .necessary__year-col.necessary__year-col_third Количество
            .necessary__year-col.necessary__year-col_third Сумма
      .table__row(v-for="(item, index) in planned")
        .table__col.table__data.table__col_small
          .custom-radio
            label.custom-radio__label
              input.visually-hidden.custom-radio__input(name="operator-input" :value="item.id" type="radio" v-model="operatorInput")
              .custom-radio__block
              .custom-radio__text № {{ index + 1 }}
        .table__col.table__data  {{ item.name }}
        .table__col.table__data.table__col_small  руб.
        .table__col.table__col_third.necessary__year-values-col
          .necessary__year-values
            .necessary__year-value.necessary__year-value_third(title="Чтобы отредактировать значение используйте двойной клик" :class="{hasError: errors[`${item.id}_${plannedYear}_price_plan`]}")
              span(
                v-if="plannedByYear[item.id][plannedYear] && !plannedByYear[item.id][plannedYear].isEditPricePlan"
                @dblclick="setPlannedEdit(item, plannedYear, 'isEditPricePlan')"
              ) {{plannedByYear[item.id][plannedYear]? getValue(plannedByYear[item.id][plannedYear].price_plan) : '-' }}
              span(
                v-if="plannedByYear[item.id][plannedYear] && plannedByYear[item.id][plannedYear].isEditPricePlan"
                title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
              )
                input.input(
                  v-model="plannedByYear[item.id][plannedYear].price_plan"
                  @blur="savePlannedEdit(item, plannedYear, 'price_plan')"
                  @keyup.enter.prevent="savePlannedEdit(item, plannedYear, 'price_plan')"
                )
              span.necessary__error(v-if="errors[`${item.id}_${plannedYear}_price_plan`]") {{errors[`${item.id}_${plannedYear}_price_plan`]}}
            .necessary__year-value.necessary__year-value_third(title="Чтобы отредактировать значение используйте двойной клик" :class="{hasError: errors[`${item.id}_${plannedYear}_quantity_plan`]}")
              span(
                v-if="plannedByYear[item.id][plannedYear] && !plannedByYear[item.id][plannedYear].isEditQuantityPlan"
                @dblclick="setPlannedEdit(item, plannedYear, 'isEditQuantityPlan')"
              ) {{plannedByYear[item.id][plannedYear]? getValue(plannedByYear[item.id][plannedYear].quantity_plan) : '-' }}
              span(
                v-if="plannedByYear[item.id][plannedYear] && plannedByYear[item.id][plannedYear].isEditQuantityPlan"
                title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
              )
                input.input(
                  v-model="plannedByYear[item.id][plannedYear].quantity_plan"
                  @blur="savePlannedEdit(item, plannedYear, 'quantity_plan')"
                  @keyup.enter.prevent="savePlannedEdit(item, plannedYear, 'quantity_plan')"
                )
            .necessary__year-value.necessary__year-value_third {{item.quantity_plan * item.price_plan}}
        .table__col.table__col_third.necessary__year-values-col
          .necessary__year-values
            .necessary__year-value.necessary__year-value_third(title="Чтобы отредактировать значение используйте двойной клик" :class="{hasError: errors[`${item.id}_${plannedYear}_price_fact`]}")
              span(
                v-if="plannedByYear[item.id][plannedYear] && !plannedByYear[item.id][plannedYear].isEditPriceFact"
                @dblclick="setPlannedEdit(item, plannedYear, 'isEditPriceFact')"
              ) {{plannedByYear[item.id][plannedYear]? getValue(plannedByYear[item.id][plannedYear].price_fact) : '-' }}
              span(
                v-if="plannedByYear[item.id][plannedYear] && plannedByYear[item.id][plannedYear].isEditPriceFact"
                title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
              )
                input.input(
                  v-model="plannedByYear[item.id][plannedYear].price_fact"
                  @blur="savePlannedEdit(item, plannedYear, 'price_fact')"
                  @keyup.enter.prevent="savePlannedEdit(item, plannedYear, 'price_fact')"
                )
              span.necessary__error(v-if="errors[`${item.id}_${plannedYear}_price_fact`]") {{errors[`${item.id}_${plannedYear}_price_fact`]}}
            .necessary__year-value.necessary__year-value_third(title="Чтобы отредактировать значение используйте двойной клик" :class="{hasError: errors[`${item.id}_${plannedYear}_quantity_fact`]}")
              span(
                v-if="plannedByYear[item.id][plannedYear] && !plannedByYear[item.id][plannedYear].isEditQuantityFact"
                @dblclick="setPlannedEdit(item, plannedYear, 'isEditQuantityFact')"
              ) {{plannedByYear[item.id][plannedYear]? getValue(plannedByYear[item.id][plannedYear].quantity_fact) : '-' }}
              span(
                v-if="plannedByYear[item.id][plannedYear] && plannedByYear[item.id][plannedYear].isEditQuantityFact"
                title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
              )
                input.input(
                  v-model="plannedByYear[item.id][plannedYear].quantity_fact"
                  @blur="savePlannedEdit(item, plannedYear, 'quantity_fact')"
                  @keyup.enter.prevent="savePlannedEdit(item, plannedYear, 'quantity_fact')"
                )
            .necessary__year-value.necessary__year-value_third {{item.quantity_fact * item.price_fact}}
      .table__row
        .table__col.table__col_small
        .table__col Итого
        .table__col.table__col_small
        .table__col.table__col_third.necessary__year-values-col
          .necessary__year-values
            .necessary__year-value.necessary__year-value_third
            .necessary__year-value.necessary__year-value_third
            .necessary__year-value.necessary__year-value_third(:class="{'red-field': pricePlanSum > nvvSum}" :title="pricePlanSum > nvvSum ? 'Сумма превышает % от НВВ' : '' ") {{pricePlanSum}}
        .table__col.table__col_third.necessary__year-values-col
          .necessary__year-values
            .necessary__year-value.necessary__year-value_third
            .necessary__year-value.necessary__year-value_third
            .necessary__year-value.necessary__year-value_third(:class="{'red-field': priceFactSum > nvvSum}" :title="priceFactSum > nvvSum ? 'Сумма превышает % от НВВ' : '' ") {{priceFactSum}}
    add-planned-purchases(
      v-if="showAddPlans"
      :tko_operator_id="tko_operator_id"
      :year="plannedYear"
      @close="closePlannedModal"
    )
</template>

<script>
import year from '@/utils/year'
import AddPlannedPurchases from './add-planned-purchases'
import yearHelper from '@/utils/year'
import { tko } from '@/api/api-endpoints'

const enumType = {
  price_fact: 'isEditPriceFact',
  price_plan: 'isEditPricePlan',
  quantity_plan: 'isEditQuantityPlan',
  quantity_fact: 'isEditQuantityFact',
}
export default {
  name: 'plannedTab',
  components: { AddPlannedPurchases },
  props: {
    tko_operator_id: {
      type: Number,
    },
  },
  data() {
    return {
      planned: [],
      fields: {
        nvv: '',
        nvv_percent: '',
      },
      plannedYears: [],
      plannedByYear: {},
      errors: {},
      showAddPlans: false,
      operatorInput: null,
      plannedYear: year.getCurrentYear(),
    }
  },
  computed: {
    yearsOptions() {
      return yearHelper.getSpecifiedYearsOptions(2023, 2032, false)
    },
    nvvSum() {
      return (this.fields.nvv * this.fields.nvv_percent) / 100
    },
    pricePlanSum() {
      return this.planned.reduce(
        (acc, item) => acc + item.price_plan * item.quantity_plan,
        0
      )
    },
    priceFactSum() {
      return this.planned.reduce(
        (acc, item) => acc + item.price_fact * item.quantity_fact,
        0
      )
    },
  },
  watch: {
    tko_operator_id: function () {
      this.getOperatorPlannedPurchases()
    },
  },
  methods: {
    async getOperatorHvv() {
      this.fields.nvv = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.operatorHvv({
            query: {
              tko_operator_id: this.tko_operator_id,
              year: this.plannedYear,
            },
          }),
        })
      ).data
    },
    async getOperatorPlannedPurchases() {
      this.$bar.start()
      this.planned = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.operatorPlannedPurchases({
            query: {
              tko_operator_id: this.tko_operator_id,
              year: this.plannedYear,
            },
          }),
        })
      ).data.data
      this.getPlannedYears()
      this.$bar.finish()
    },
    async savePlannedEdit(item, year, type) {
      this.$bar.start()
      if (this.plannedByYear[item.id][year][type] < 0) {
        this.plannedByYear[item.id][year][type] = 0
      }
      try {
        await this.$store.dispatch('updateModel', {
          url: tko.operatorPlannedPurchasesById(item.id),
          data: {
            id: item.id,
            [type]: this.plannedByYear[item.id][year][type],
            year,
          },
        })

        this.plannedByYear[item.id][year][enumType[type]] = false[
          ('price_plan', 'price_fact', 'quantity_plan', 'quantity_fact')
        ].forEach((el) => {
          this.$delete(this.errors, `${item.id}_${year}_${el}`)
        })
        this.getOperatorPlannedPurchases()
      } catch (e) {
        const errors = JSON.parse(this.$store.getters.getError.message)[
          ('price_plan', 'price_fact', 'quantity_plan', 'quantity_fact')
        ].forEach((item) => {
          if (errors[item]) {
            this.$set(this.errors, `${item.id}_${year}_${item}`, errors[item])
          }
        })
      } finally {
        this.$bar.finish()
      }
    },
    async deletePlannedItem() {
      this.$bar.start()
      await this.$store.dispatch('deleteModel', {
        url: tko.operatorPlannedPurchasesById(this.operatorInput),
      })
      this.operatorInput = null
      this.getOperatorPlannedPurchases()
    },
    getPlannedYears() {
      this.planned.forEach((item) => {
        this.$set(this.plannedByYear, item.id, {})
        this.plannedYears.push(item.year)
        this.$set(this.plannedByYear[item.id], item.year, {
          price_fact: item.price_fact,
          price_plan: item.price_plan,
          quantity_fact: item.quantity_fact,
          quantity_plan: item.quantity_plan,
          isEditPricePlan: false,
          isEditPriceFact: false,
          isEditQuantityPlan: false,
          isEditQuantityFact: false,
        })

        Object.values(this.plannedByYear).forEach((el) => {
          this.plannedYears.forEach((year) => {
            if (!el[year]) {
              this.$set(this.plannedByYear[item.id], year, {
                price_fact: null,
                price_plan: null,
                quantity_fact: null,
                quantity_plan: null,
                isEditPricePlan: false,
                isEditPriceFact: false,
                isEditQuantityPlan: false,
                isEditQuantityFact: false,
              })
            }
          })
        })
      })
      this.plannedYears = Array.from(new Set(this.plannedYears))
    },
    setPlannedEdit(item, year, type) {
      this.plannedByYear[item.id][year][type] =
        !this.plannedByYear[item.id][year][type]
    },
    closePlannedModal() {
      this.showAddPlans = false
      this.getOperatorPlannedPurchases()
    },
    getValue(name) {
      return name ? name : '0'
    },
  },
  created() {
    this.getOperatorHvv()
    this.getOperatorPlannedPurchases()
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/utils/variables';

.necessary {
  &__buttons {
    display: flex;
    gap: 10px;
  }
}

.table {
  &__col {
    &_third {
      width: 33%;
      min-width: 300px;
      max-width: 300px;
    }
  }
}

.red-field {
  background-color: $danger;
}
</style>
